'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { BrowserObservability } from '@qogita/observability/browser-observability'
// oxlint-disable-next-line @qogita/no-deprecated-imports -- intentional bridge for legacy pages router
import { useUserContext } from 'src/deprecated/contexts/User'

import { NEXT_PUBLIC_OBSERVABILITY_ENABLED } from './config'

/**
 * Pages-router Faro user identification via `UserProvider` / `useUserContext()`
 * (same source as the rest of the legacy app: React Query `userQueries.detail()`).
 * Render inside `UserProvider` (e.g. from `pages/_app.tsx`).
 */
export function BrowserObservabilityPagesRouter() {
  const user = useUserContext()

  const observabilityUserPromise = user
    ? Promise.resolve({
        status: 'authenticated' as const,
        id: user.qid,
        email: user.email,
      })
    : Promise.resolve({ status: 'anonymous' as const })

  if (!NEXT_PUBLIC_OBSERVABILITY_ENABLED) {
    return null
  }

  return <BrowserObservability userPromise={observabilityUserPromise} />
}
